"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProperties = getProperties;
const adapter_core_1 = require("@aws-amplify/core/internals/adapter-core");
const getProperties_1 = require("../internal/getProperties");
function getProperties(contextSpec, input) {
    return (0, getProperties_1.getProperties)((0, adapter_core_1.getAmplifyServerContext)(contextSpec).amplify, input);
}
